import Goals from './goals'

export default Goals